import { AbacoWebModule, ApplicationReadyEvent } from "@abaco/web-common/src/app";
import { createGlobals, deleteGlobals, normalGlobals } from "./globals";
import GlobalStateModule from "@abaco/portal-global-state/src/modules/global-state/index";
import OldWidgetApi from './api/OldWidgetApi';
import SSOModule from '@abaco/sso-web-module/src/abaco-module';
import { WidgetMap, WidgetParam } from './models/Widget';
import DashboardModule from '@abaco/dashboard-module/src/modules/dashboard';
import FarmerRegistryModule from "@abaco/farm-registry/src/modules/farm-registry";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import OldWidgetVuexModule from "./state";
import SatellitesWidgetModule from "../satellites-widgets";

export const MODULE_ID = "old_widgets_module";

export default class OldWidgetsModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;
    public widgetParams: WidgetMap = {};
    public readonly environment: string;

    readonly id = MODULE_ID;
    readonly globalComponents = normalGlobals;
    readonly vuexModule = new OldWidgetVuexModule();

    private oldWApi!: OldWidgetApi;
    private ssoModule!: SSOModule;
    private dashboardModule!: DashboardModule;
    private alreadyAdded = false;
    private alreadyCreated = false;
    private http!: HTTPClient;

    constructor(environment = "") {
        this.environment = environment;
    }

    dependsOn = {
        [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule(),
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [SatellitesWidgetModule.MODULE_ID]: () => new SatellitesWidgetModule()
    }

    async onApplicationReady(evt: ApplicationReadyEvent) {
        const ssoModule = evt.modules.find((m) => m.id === SSOModule.MODULE_ID) as SSOModule | undefined;
        const dashboardModule = evt.modules.find((m) => m.id === DashboardModule.MODULE_ID) as DashboardModule | undefined;
        if (!ssoModule || !dashboardModule) {
            throw new Error("SSOModule | DashboardModule not found!");
        }
        this.ssoModule = ssoModule;
        this.dashboardModule = dashboardModule;
        this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        this.addWidgets();
    }

    public async addWidgets() {
        if (this.alreadyAdded) {
            return;
        }
        this.alreadyAdded = true;
        const OldWidgetApi = (await import("./api/OldWidgetApi")).default;
        this.oldWApi = new OldWidgetApi(this.http, this.ssoModule);

        try {
            const widgetTempList: WidgetParam[] = await this.oldWApi.getWidgetParams();
            const isColdiretti = this.environment.includes("coldiretti") ? true : false;

            widgetTempList.forEach(element => {
                this.widgetParams[element.widgetCode] = element;
                let fullTitle = element.widgetCode.toLowerCase();
                if (element.widgetCode === "AGRIMETEO_HIST_TSUOLO" && isColdiretti) {
                    fullTitle = fullTitle + "-coldiretti";
                }
                this.widgetParams[element.widgetCode].title = fullTitle;
            });

            createGlobals(this.widgetParams, this.dashboardModule.pinnableTiles, this.dashboardModule.modulesByTileID, isColdiretti, this);
        } catch (error) {
            console.error(error);
        }
    }

    public get oldWidgetApi() {
        return this.oldWApi;
    }

    public resetCache() {
        const isColdiretti = this.environment.includes("coldiretti") ? true : false;
        if (this.dashboardModule && this.alreadyAdded) {
            deleteGlobals(this.widgetParams, this.dashboardModule.pinnableTiles, isColdiretti);
            this.widgetParams = {};
            this.alreadyAdded = false;
        }
        this.addWidgets()
    }
}
